const PLAYLIST_CHILL_LYRICS = {
    'vi-me-anh-bat-chia-tay': [
        { start: 17, end: 21, text: `Anh rất tốt thế nhưng thà đừng gặp vui hơn` },
        { start: 21, end: 25, text: `Em rất tiếc thế nhưng thà làm người cô đơn` },
        { start: 25, end: 30, text: `Sẽ chẳng phải thốt lên hài hước như lúc này` },
        { start: 30, end: 33, text: `Rằng mẹ anh bắt chia tay` },
        { start: 33, end: 37, text: `Anh cũng rất tốt thế nhưng mình chẳng hợp nhau đâu` },
        { start: 37, end: 41, text: `Em có chút tiếc nuối khi mình chẳng phải cô dâu` },
        { start: 41, end: 46, text: `Em sẽ ghé đám cưới anh và nói lời này` },
        { start: 46, end: 48, text: `"Chúc anh hạnh phúc, chỉ một ngày!"` },
        { start: 48, end: 50, text: `Có gì đâu mà phải khóc` },
        { start: 50, end: 52, text: `Không có anh thì sẽ có người khác` },
        { start: 52, end: 54, text: `Tình nào mà tình chẳng dang dở` },
        { start: 54, end: 56, text: `Vui rồi cũng đến lúc phải tẻ nhạt` },
        { start: 56, end: 58, text: `Em nghĩ nhiều làm gì cho mệt đầu` },
        { start: 58, end: 60, text: `Cứ mặc định anh là thằng tệ bạc` },
        {
            start: 60,
            end: 63,
            text: `Thừa biết hạnh phúc của em là kim cương nhưng lại không thể trở thành người chế tác`,
        },
        {
            start: 63,
            end: 68,
            text: `Một phần anh muốn tập trung cho sự nghiệp nên tình cảm này anh buộc phải cự tuyệt`,
        },
        {
            start: 68,
            end: 72,
            text: `Mặt khác anh sợ cảm giác phải yêu xa, mình không tới đâu cũng khó lòng từ biệt`,
        },
        { start: 72, end: 76, text: `Trong mắt anh thật sự em rất tuyệt dù rằng hai đứa không hợp nhau là mấy` },
        { start: 76, end: 81, text: `Em rất tốt nhưng mà anh rất tiếc, mẹ của anh bắt anh phải chia tay` },
        { start: 81, end: 83, text: `Anh rất tốt thế nhưng...` },
        { start: 83, end: 85, text: `Tình cảnh ta không còn như xưa` },
        { start: 85, end: 87, text: `Em rất tiếc thế nhưng...` },
        { start: 87, end: 89, text: `Anh không có quyền để chọn lựa` },
        { start: 89, end: 91, text: `Anh rất tốt thế nhưng...` },
        { start: 91, end: 93, text: `Xin lỗi vì những gì đã hứa` },
        { start: 93, end: 95, text: `Em rất tiếc thế nhưng...` },
        { start: 95, end: 97, text: `Về đi để anh còn đóng cửa` },
        { start: 97, end: 101, text: `Anh rất tốt thế nhưng thà đừng gặp vui hơn` },
        { start: 101, end: 105, text: `Em rất tiếc thế nhưng thà làm người cô đơn` },
        { start: 105, end: 110, text: `Sẽ chẳng phải thốt lên hài hước như lúc này` },
        { start: 110, end: 113, text: `Rằng mẹ anh bắt chia tay` },
        { start: 113, end: 117, text: `Anh cũng rất tốt thế nhưng mình chẳng hợp nhau đâu` },
        { start: 117, end: 121, text: `Em có chút tiếc nuối khi mình chẳng phải cô dâu` },
        { start: 121, end: 126, text: `Em sẽ ghé đám cưới anh và nói lời này` },
        { start: 126, end: 128, text: `"Chúc anh hạnh phúc, chỉ một ngày!"` },
        { start: 128, end: 132, text: `Trái tim của anh thì nói có, nhưng mẹ của anh thì nói không` },
        { start: 132, end: 135, text: `Rõ tương lai đã không có, càng dây dưa chỉ càng thêm nhói lòng` },
        { start: 135, end: 140, text: `Thật ra anh chỉ xem em như em gái, cảm mến vì những câu chuyện em từng trải` },
        {
            start: 140,
            end: 144,
            text: `Sẽ rất sai nếu cả hai quyết định đi đường dài cho nên tốt nhất anh nghĩ nên dừng lại`,
        },
        { start: 144, end: 147, text: `Anh từng cho rằng mình không thể ác đến khi vượt qua` },
        {
            start: 147,
            end: 152,
            text: `Nỗi đau thể xác nhận ra sắt đá còn có thể bạc thì tình cảm mình sao không thể khác?`,
        },
        { start: 152, end: 156, text: `Có những lúc để hạnh phúc thật sự buộc lòng nước mắt cả hai phải rơi xuống` },
        { start: 156, end: 160, text: `Cơ bản cuộc đời này là buồn, dù không muốn rồi vẫn phải tập buông` },
        { start: 160, end: 164, text: `Coi như mình kết thúc đúng lúc, từ ngày mai cả hai đừng nhớ gì` },
        { start: 164, end: 168, text: `Không nhất thiết phải chúc anh hạnh phúc, nhưng ngày cưới của anh em nhớ đi` },
        { start: 168, end: 172, text: `Quên phong bì cũng không sao, tới và về miễn đừng để ai thấy` },
        { start: 172, end: 178, text: `Chuyện cũ xin đừng kể ai hay, có thuộc cũng đừng hát tặng anh bài này` },
        { start: 178, end: 181, text: `Anh rất tốt thế nhưng thà đừng gặp vui hơn` },
        { start: 181, end: 185, text: `Em rất tiếc thế nhưng thà làm người cô đơn` },
        { start: 185, end: 190, text: `Sẽ chẳng phải thốt lên hài hước như lúc này (lúc này)` },
        { start: 190, end: 194, text: `Rằng mẹ anh bắt chia tay` },
        { start: 194, end: 197, text: `Anh cũng rất tốt thế nhưng mình chẳng hợp nhau đâu` },
        { start: 197, end: 201, text: `Em có chút tiếc nuối khi mình chẳng phải cô dâu` },
        { start: 201, end: 206, text: `Em sẽ ghé đám cưới anh và nói lời này` },
        { start: 206, end: 213, text: `"Chúc anh hạnh phúc, chỉ một ngày!"` },
        { start: 241, end: 245, text: `Hãy sống tốt nhé anh` },
        { start: 245, end: 249, text: `Em rất tiếc thế nhưng...` },
        { start: 249, end: 254, text: `Hãy sống tốt nhé anh` },
        { start: 254, end: 260, text: `Vì mẹ anh bắt chia tay` },
    ],
    'waiting-foy-you': [
        { start: 25, end: 30, text: `Chiều đang dần buông hạt mưa rơi xuống không gian lắng yên` },
        { start: 30, end: 33, text: `Suy tư vấn vương ngồi mộng mơ` },
        { start: 33, end: 36, text: `Đơn phương nhớ đến một nàng thơ` },
        { start: 36, end: 38, text: `Gió đông ùa về mang những ê chề (woh)` },
        { start: 38, end: 43, text: `Ngỡ là trái tim khô cằn héo úa sẽ thôi buồn đau` },
        { start: 43, end: 46, text: `Nhưng thật cay đắng khi biết là (ú oà)` },
        { start: 46, end: 50, text: `Mình chỉ là một người đến sau (hey)` },
        { start: 50, end: 52, text: `Biết em đã có người ở gần bên` },
        { start: 52, end: 55, text: `Nhưng anh sẽ vẫn đứng ngay đây và chờ em` },
        { start: 55, end: 58, text: `Mưa giông bão tố chẳng quan tâm đến ngày đêm` },
        { start: 58, end: 62, text: `Kẻ si tình này chọn ở phía sau thầm nhớ mong em bae bae` },
        { start: 62, end: 65, text: `Vì say mê ánh mắt yêu luôn cả bờ môi` },
        { start: 65, end: 68, text: `Muốn nói với cả thế giới chỉ thương em mà thôi` },
        { start: 68, end: 71, text: `Đắm đuối uh cháy lên ngọn lửa tình yêu` },
        { start: 71, end: 75, text: `Bùng lên mạnh mẽ và thiêu đốt baby that’s what I feel` },
        { start: 75, end: 83, text: `My girl I’m waiting for you` },
        { start: 102, end: 107, text: `Một bông hồng xinh tươi thắm huh trông em kiêu sa` },
        { start: 107, end: 110, text: `Đôi chân thướt tha mặn mà (uh)` },
        { start: 110, end: 113, text: `Hương thơm miên man dịu dàng (uh)` },
        { start: 113, end: 115, text: `Dáng duyên nụ cười say đắm yêu người` },
        { start: 115, end: 120, text: `Ngỡ là trái tim khô cằn héo úa sẽ thôi buồn đau` },
        { start: 120, end: 123, text: `Nhưng thật cay đắng khi biết là (ú oà)` },
        { start: 123, end: 126, text: `Mình chỉ là một người đến sau (hey)` },
        { start: 126, end: 129, text: `Biết em đã có người ở gần bên` },
        { start: 129, end: 132, text: `Nhưng anh sẽ vẫn đứng ngay đây và chờ em` },
        { start: 132, end: 135, text: `Mưa giông bão tố chẳng quan tâm đến ngày đêm` },
        { start: 135, end: 138, text: `Kẻ si tình này chọn ở phía sau thầm nhớ mong em bae bae` },
        { start: 138, end: 142, text: `Vì say mê ánh mắt yêu luôn cả bờ môi` },
        { start: 142, end: 145, text: `Muốn nói với cả thế giới chỉ thương em mà thôi` },
        { start: 145, end: 148, text: `Đắm đuối uh cháy lên ngọn lửa tình yêu` },
        { start: 148, end: 152, text: `Bùng lên mạnh mẽ và thiêu đốt baby that’s what I feel` },
        { start: 152, end: 154, text: `My girl I’m waiting for you` },
        { start: 154, end: 157, text: `I’m waiting for you (oh oh)` },
        { start: 157, end: 160, text: `I’m waiting for you (oh oh)` },
        { start: 160, end: 162, text: `Chờ em về đây với anh` },
        { start: 162, end: 164, text: `Mình cùng đan bàn tay` },
        { start: 164, end: 166, text: `Ấm áp bao đêm ngày` },
        { start: 166, end: 168, text: `Yeah` },
        { start: 168, end: 171, text: `Chờ em chờ em ừ thì chờ em` },
        { start: 171, end: 174, text: `Chờ em chờ em chờ đến bao giờ` },
        { start: 174, end: 177, text: `Biển khô cạn trời không còn đầy sao` },
        { start: 177, end: 179, text: `Thì anh vẫn nơi đây và chờ em` },
        { start: 179, end: 181, text: `Biết em đã có người ở gần bên` },
        { start: 181, end: 184, text: `Nhưng anh sẽ vẫn đứng ngay đây và chờ em` },
        { start: 184, end: 187, text: `Mưa giông bão tố chẳng quan tâm đến ngày đêm` },
        { start: 187, end: 191, text: `Kẻ si tình này chọn ở phía sau thầm nhớ mong em bae bae` },
        { start: 191, end: 194, text: `Vì say mê ánh mắt yêu luôn cả bờ môi` },
        { start: 194, end: 197, text: `Muốn nói với cả thế giới chỉ thương em mà thôi` },
        { start: 197, end: 200, text: `Đắm đuối uh cháy lên ngọn lửa tình yêu` },
        { start: 200, end: 204, text: `Bùng lên mạnh mẽ và thiêu đốt baby that’s what I feel` },
        { start: 204, end: 212, text: `My girl I’m waiting for you` },
    ],
    'tu-thich-thich-thanh-thuong-thuong': [
        { start: 5, end: 9, text: `Anh ơi em đâu dám nói` },
        { start: 9, end: 14, text: `Khi con tim em đang bối rối` },
        { start: 14, end: 18, text: `Những lần mình hẹn nhau` },
        { start: 18, end: 23, text: `Những lần không thành câu` },
        { start: 23, end: 28, text: `Những ngại ngùng buồn vu vơ trong trái tim này` },
        { start: 28, end: 32, text: `Những lần ôm mộng mơ ôi tay nắm tay` },
        { start: 32, end: 36, text: `Biết làm gì giờ em nhận ra` },
        { start: 36, end: 40, text: `Từ thích thích thành yêu yêu rồi thương thương` },
        { start: 40, end: 45, text: `Nên em đành viết chiếc thư tình thư tình` },
        { start: 45, end: 50, text: `Để thay em nói hết tâm tư trong mình` },
        { start: 50, end: 54, text: `Mong anh đừng nói những lời từ chối` },
        { start: 54, end: 60, text: `Em chỉ cần biết tâm tư anh thế thôi` },
        { start: 60, end: 64, text: `Em ơi anh đâu dễ dàng nói ra nên lời` },
        { start: 64, end: 70, text: `Rằng trong lòng anh từ lâu cũng thấy rối bời` },
        { start: 70, end: 73, text: `Nhưng hai ta nên chầm chậm thế thôi em à` },
        { start: 73, end: 78, text: `Từ thích thích thành yêu yêu rồi thương thương` },
        { start: 78, end: 82, text: `Ngày anh thấy thấy tim đập nhanh lúc bên em` },
        { start: 82, end: 88, text: `Là anh đã biết biết anh chẳng có một đường lui` },
        { start: 88, end: 91, text: `Thấy thấy như trạm xăng với ô tô` },
        { start: 91, end: 96, text: `Vì gặp em là anh chỉ đổ mà thôi` },
        { start: 96, end: 101, text: `Nên em đành viết chiếc thư tình thư tình` },
        { start: 101, end: 105, text: `Để thay em nói hết tâm tư trong mình` },
        { start: 105, end: 110, text: `Mong anh đừng nói những lời từ chối` },
        { start: 110, end: 118, text: `Em chỉ cần biết tâm tư anh thế thôi` },
        { start: 124, end: 134, text: `Dada dada` },
        { start: 134, end: 136, text: `Nếu mình yêu ai hết lòng` },
        { start: 136, end: 138, text: `Người ta cũng chờ mong để đáp lại` },
        { start: 138, end: 143, text: `Thì trên đời đâu tồn tại hai chữ đơn phương` },
        { start: 143, end: 145, text: `Nếu mình yêu ai hết lòng` },
        { start: 145, end: 148, text: `Người ta cũng chờ mong để đáp lại` },
        { start: 148, end: 152, text: `Thì trên đời đâu tồn tại hai chữ đơn phương` },
        { start: 152, end: 171, text: `Dada dada dada dada` },
        { start: 171, end: 173, text: `Nếu mình yêu ai hết lòng` },
        { start: 173, end: 175, text: `Người ta cũng chờ mong để đáp lại` },
        { start: 175, end: 180, text: `Thì trên đời đâu tồn tại hai chữ đơn phương` },
        { start: 180, end: 182, text: `Nếu mình yêu ai hết lòng` },
        { start: 182, end: 185, text: `Người ta cũng chờ mong để đáp lại` },
        { start: 185, end: 189, text: `Thì trên đời đâu tồn tại hai chữ đơn phương` },
        { start: 189, end: 199, text: `Thì trên đời đâu tồn tại hai chữ đơn phương` },
    ],
    'mot-nguoi-nhe-nhang-hon': [
        { start: 12, end: 16, text: `Đã mất một thời gian khá lâu` },
        { start: 16, end: 22, text: `Để quên anh` },
        { start: 22, end: 26, text: `Đôi khi giật mình những thói quen` },
        { start: 26, end: 33, text: `Lòng chợt nhớ nhung về những ngày xưa` },
        { start: 33, end: 38, text: `Ta từng yêu thế nào` },
        { start: 38, end: 43, text: `Môi hôn anh ngọt ngào` },
        { start: 43, end: 49, text: `Người ta vẫn nói nếu còn luyến lưu điều gì` },
        { start: 49, end: 53, text: `Là do mình còn ngu si` },
        { start: 53, end: 63, text: `Vì anh ơi thật ra em không còn ngu ngốc nữa rồi` },
        { start: 63, end: 70, text: `Và anh ơi thật ra là em chỉ muốn...` },
        { start: 70, end: 75, text: `Để anh thấy em đang vui thế nào` },
        { start: 75, end: 80, text: `Để anh thấy em xinh đẹp ra sao` },
        { start: 80, end: 95, text: `Và đang yêu một người nhẹ nhàng hơn` },
        { start: 95, end: 98, text: `Trôi qua vài năm đã lâu` },
        { start: 98, end: 105, text: `Từ khi em tìm ra chính mình` },
        { start: 105, end: 108, text: `Đi qua một nơi quán quen` },
        { start: 108, end: 116, text: `Trả lại con phố như ngày chưa có anh` },
        { start: 116, end: 120, text: `Ta từng cố gắng tha thứ (Ta từng cố gắng rất nhiều)` },
        { start: 120, end: 126, text: `Từng mong quay đầu lại (no-no-no...)` },
        { start: 126, end: 132, text: `Người ta luôn nói nếu còn luyến lưu điều gì (nếu ta còn luyến lưu)` },
        { start: 132, end: 135, text: `Là do mình còn ngu si` },
        { start: 135, end: 145, text: `Vì anh ơi thật ra em không còn ngu ngốc nữa rồi` },
        { start: 145, end: 152, text: `Và anh ơi thật ra là em chỉ muốn...` },
        { start: 152, end: 157, text: `Để anh thấy em đang vui thế nào` },
        { start: 157, end: 163, text: `Để anh thấy em xinh đẹp ra sao` },
        { start: 163, end: 171, text: `Và đang yêu một người tuyệt vời hơn` },
        { start: 198, end: 208, text: `Vì anh ơi thật ra em không còn ngu ngốc nữa rồi` },
        { start: 208, end: 215, text: `Và anh ơi thật ra là... (thật ra là em rất muốn)` },
        { start: 215, end: 220, text: `Để anh thấy em đang vui thế nào` },
        { start: 220, end: 225, text: `Để anh thấy em xinh đẹp ra sao` },
        { start: 225, end: 238, text: `Và đang yêu một người tuyệt vời hơn ("Really?")` },
        { start: 237, end: 238, text: `"No"` },
    ],
    'em-bo-hut-thuoc-chua': [
        { start: 18, end: 20, text: `“em lâu nay ra sao?”` },
        { start: 20, end: 27, text: `Sau bao năm chia tay, nay tự nhiên lại hỏi em ra sao?` },
        { start: 27, end: 35, text: `Khi mưa đêm đang rơi, em không nghĩ em sẽ sẵn sàng ôn lại kỷ niệm không vui` },
        { start: 35, end: 44, text: `Ngày xưa anh luôn nghĩ em ở đó, luôn ở đó` },
        { start: 44, end: 53, text: `Mà trong khi em biết, anh thì muốn, được tự do` },
        { start: 53, end: 62, text: `“đến khi nào em mới biết bỏ thuốc nhở?”` },
        { start: 62, end: 72, text: `Đấy đâu phải là những thứ cần biết nhở?` },
        { start: 72, end: 81, text: `Người mà em yêu em còn chia tay được theo anh thuốc lá đã là gì?` },
        { start: 81, end: 89, text: `Thì chẳng qua em đang chưa muốn thôi anh,anh đâu cần quan tâm làm gì?` },
        {
            start: 89,
            end: 99,
            text: `Đừng vội vàng hờn trách em, chỉ là vài dòng nhắn tin, mà lại lạnh lùng như thế`,
        },
        { start: 99, end: 119, text: `Vài dòng vu vơ hay thật ra anh đang cô đơn nên nhắn tin giờ này` },
        { start: 126, end: 136, text: `Thực ra anh đang nhớ em hay chỉ nhớ một cảm giác?` },
        { start: 136, end: 145, text: `Tại sao anh yêu biết bao người mà vẫn không hiểu tình yêu?` },
        { start: 145, end: 154, text: `“đến khi nào em mới biết bỏ thuốc nhở?”` },
        { start: 154, end: 163, text: `Chớ nên hỏi em câu đấy, em thấy.. nực cười` },
        { start: 163, end: 173, text: `Người mà em yêu em còn chia tay được theo anh thuốc lá đã là gì?` },
        { start: 173, end: 181, text: `Thì chẳng qua em đang chưa muốn thôi anh,anh đâu cần quan tâm làm gì?` },
        {
            start: 181,
            end: 191,
            text: `Điều mình cần phải nói ra, một sự thật là chúng ta chẳng còn gì ngoài quá khứ`,
        },
        { start: 191, end: 201, text: `Ngày còn yêu sao không lo lắng cho nhau, chia tay rồi quan tâm làm gì?` },
    ],
    'replay-tren-con-guay': [
        { start: 1, end: 7, text: `Dù là viển vông mấy, em mong replay trên con Guây` },
        { start: 7, end: 12, text: `Replay cảnh ta đã ôm nhau, hôn nhau trên con Guây` },
        { start: 12, end: 17, text: `Nhiều thứ nên tua nhanh, trừ ngày tháng em bên anh` },
        { start: 17, end: 24, text: `Replay đi, em nhớ anh, em mong xe ta không phanh, yeah ye-yeah` },
        { start: 24, end: 27, text: `Không còn em để ngắm, hai gương anh chẳng buồn gắng lau` },
        { start: 27, end: 29, text: `Lau làm gì để thấy cô đơn ngồi ngay ngắn sau?` },
        { start: 29, end: 32, text: `Chờ hỏi câu đau thắt rằng, "Xe kia còn gắn máy?"` },
        { start: 32, end: 34, text: `"Cớ sao người chẳng còn gắn nhau?'"` },
        { start: 34, end: 36, text: `Chẳng còn những đêm anh lướt thật êm, bảo sao em không say mãi` },
        { start: 36, end: 39, text: `Đời anh nhiều thứ không chắc, nhưng nó đếch phải tay lái` },
        { start: 39, end: 42, text: `Ngày ấy phố lạ chỉ như mảnh vườn cho mình thong dong` },
        { start: 42, end: 45, text: `Ta giống như lũ thỏ xù, ai cũng thấy mình lông bông` },
        { start: 45, end: 47, text: `Quên ăn vì ta đói lượn hơn bất kì cơn đói nào` },
        { start: 47, end: 50, text: `Kệ quán xá vì vai anh mới là nơi em muốn ghé vào` },
        { start: 50, end: 53, text: `Ta chọn đến với nhau thì kĩ, chứ chọn đến đâu thì qua loa` },
        { start: 53, end: 55, text: `Vì mình là đôi ong bướm, chỉ cần thân mật, không xa hoa` },
        { start: 55, end: 58, text: `Ở trong túi em luôn là điện thoại, mẹ nhắn về nhà nhanh lên` },
        { start: 58, end: 61, text: `Ở trong túi anh rỗng tuếch, để dành chỗ cho đôi bàn tay em` },
        { start: 61, end: 63, text: `Ở trên con xe ngày ấy, thiếu niên nhưng thừa ngọt ngào` },
        { start: 63, end: 66, text: `Vì tiền mình chỉ đủ mua đường, chứ làm giề có lựa chọn nào` },
        { start: 66, end: 67, text: `Mình chỉ có` },
        { start: 67, end: 69, text: `Xe máy rẻ, tình yêu sang` },
        { start: 69, end: 72, text: `Xe máy rẻ, tình yêu sang` },
        { start: 72, end: 73, text: `Xe máy rẻ, tình yêu sang` },
        { start: 73, end: 75, text: `Không thích dừng vì mất vibe` },
        { start: 75, end: 77, text: `Nếu đích đến là hạnh phúc, không nhất mình thì nhất ai` },
        { start: 77, end: 80, text: `Xe máy rẻ, tình yêu sang` },
        { start: 80, end: 83, text: `Xe máy rẻ, tình yêu sang` },
        { start: 83, end: 84, text: `Xe máy rẻ, tình yêu sang` },
        { start: 84, end: 85, text: `Không thích dừng vì mất vibe` },
        { start: 85, end: 87, text: `Nếu đích đến là hạnh phúc, không nhất mình thì nhất ai` },
        { start: 87, end: 92, text: `Dù là viển vông mấy, em mong replay trên con Guây` },
        { start: 92, end: 97, text: `Replay cảnh ta đã ôm nhau, hôn nhau trên con Guây` },
        { start: 97, end: 103, text: `Bỏ trốn đêm hôm ấy, điện thoại chúng ta tắt máy` },
        { start: 103, end: 109, text: `Replay đi, em nhớ anh, em mong xe ta không phanh, yeah ye-yeah` },
        { start: 109, end: 112, text: `Ngày đó tiếng cười, lời ca của em luôn làm anh mất hồn` },
        { start: 112, end: 115, text: `Giờ thiếu nó anh nhận ra là con Guây của anh rất ồn` },
        { start: 115, end: 117, text: `Hương tóc em lưu luyến luôn khiến anh đêm về mộng mơ` },
        { start: 117, end: 120, text: `Thiếu nó anh mới để ý con Guây anh khét mùi động cơ` },
        { start: 120, end: 123, text: `Hóa ra mỗi khi có em ở bên, con xe này có thể rời thực tại` },
        { start: 123, end: 125, text: `Khi bánh xe còn lăn, thì mọi chuyện đời dừng lại` },
        { start: 125, end: 128, text: `Mọi gánh nặng tan biến ở nơi em chạm tay qua` },
        { start: 128, end: 131, text: `Làm anh rung động từng giây, biến anh thành đàn guitar` },
        { start: 131, end: 133, text: `Em làm anh thấy lượn trên phố lãng mạn như phim` },
        { start: 133, end: 135, text: `Nghiện đưa em đi thật xa để trở về như Soobin` },
        { start: 135, end: 138, text: `Gặp xe mới hay người mới bây giờ anh đều khó quen` },
        { start: 138, end: 141, text: `Anh chẳng còn thích xe sang nào ngoài xe sang đón em` },
        { start: 141, end: 143, text: `Nên nếu thời gian có thể lại quay ngược đi` },
        { start: 143, end: 146, text: `Hãy cho anh được đèo em thêm lại một lần` },
        { start: 146, end: 148, text: `Người ta nói yêu nhau yêu cả đường đi` },
        { start: 148, end: 151, text: `Anh chỉ tiếc là đường đi mình không thể dài vô tận` },
        { start: 151, end: 152, text: `Mình chẳng còn` },
        { start: 152, end: 154, text: `Xe máy rẻ, tình yêu sang` },
        { start: 154, end: 157, text: `Xe máy rẻ, tình yêu sang` },
        { start: 157, end: 158, text: `Xe máy rẻ, tình yêu sang` },
        { start: 158, end: 160, text: `Không thích dừng vì mất vibe` },
        { start: 160, end: 162, text: `Nếu đích đến là hạnh phúc, không nhất mình thì nhất ai` },
        { start: 162, end: 165, text: `Xe máy rẻ, tình yêu sang` },
        { start: 165, end: 168, text: `Xe máy rẻ, tình yêu sang` },
        { start: 168, end: 169, text: `Xe máy rẻ, tình yêu sang` },
        { start: 169, end: 170, text: `Không thích dừng vì mất vibe` },
        { start: 170, end: 172, text: `Nếu đích đến là hạnh phúc, không nhất mình thì nhất ai` },
        {
            start: 172,
            end: 177,
            text: `Dù là viển vông mấy, em mong replay trên con Guây (trên con Guây, trên con Guây)`,
        },
        {
            start: 177,
            end: 182,
            text: `Replay cảnh ta đã ôm nhau, hôn nhau trên con Guây (trên con Guây, trên con Guây)`,
        },
        { start: 182, end: 188, text: `Nhiều thứ nên tua nhanh, trừ ngày tháng em bên anh (yo, yo)` },
        {
            start: 188,
            end: 195,
            text: `Replay đi, em nhớ anh, em mong xe ta không phanh, yeah ye-yeah (lên xe, lên xe)`,
        },
        { start: 195, end: 197, text: `Replay trên con Guây` },
        { start: 197, end: 200, text: `Replay trên con Guây` },
        { start: 200, end: 203, text: `Replay trên con Guây` },
        { start: 203, end: 205, text: `Đôi ta đét đèn đẹt nhở` },
        { start: 205, end: 208, text: `Replay trên con Guây` },
        { start: 208, end: 211, text: `Replay trên con Guây` },
        { start: 211, end: 213, text: `Replay trên con Guây` },
        { start: 213, end: 219, text: `Đôi ta đét đèn đẹt nhở` },
    ],
    'chuyen-rang': [
        { start: 2, end: 19, text: `Lal lal lal hah` },
        { start: 19, end: 23, text: `Khi đêm ùa vào ôm chặt em` },
        { start: 23, end: 28, text: `Oh I'm just a boy` },
        { start: 28, end: 33, text: `Chẳng thể là quá muộn khi nói lời yêu một người` },
        { start: 33, end: 39, text: `Chẳng thể là quá muộn khi ta hoài tiếc một đời` },
        { start: 39, end: 49, text: `Những lời yêu sao quá khó khăn` },
        { start: 49, end: 54, text: `Kìa những tháng năm dài ta đã cùng đi bên nhau` },
        { start: 54, end: 59, text: `Nhìn đoá môi em cười cho ta một vết thương sâu` },
        { start: 59, end: 66, text: `Những lời yêu sao quá khó khăn` },
        { start: 66, end: 71, text: `Chuyện rằng huh huh huh huh mơ màng` },
        { start: 71, end: 76, text: `Anh giam yêu dấu trong anh từng phút yên lặng` },
        { start: 76, end: 79, text: `Là từng câu hát anh yêu em` },
        { start: 79, end: 83, text: `Viết ra không tên` },
        { start: 83, end: 86, text: `Khi đêm đen về` },
        { start: 86, end: 91, text: `Chuyện rằng năm tháng cứ trôi chẳng thấy quay lại` },
        { start: 91, end: 96, text: `Tại sao anh vẫn đau khi nhìn thấy em bên ai` },
        { start: 96, end: 99, text: `Liệu rằng câu hát anh yêu em` },
        { start: 99, end: 106, text: `Sẽ đến bên em khi đêm ùa vào ôm chặt em` },
        { start: 106, end: 114, text: `Oh I'm just a boy` },
        { start: 129, end: 134, text: `Tìm thấy nhau cả rồi nhưng trong lòng vẫn chơi vơi` },
        { start: 134, end: 140, text: `Thả tiếng yêu không lời trôi theo ngọn gió muôn nơi` },
        { start: 140, end: 146, text: `Những lời yêu sao quá khó khăn` },
        { start: 146, end: 151, text: `Chuyện rằng huh huh huh huh mơ màng` },
        { start: 151, end: 156, text: `Anh giam yêu dấu trong anh từng phút yên lặng` },
        { start: 156, end: 160, text: `Là từng câu hát anh yêu em` },
        { start: 160, end: 164, text: `Viết ra không tên` },
        { start: 164, end: 167, text: `Khi đêm đen về` },
        { start: 167, end: 172, text: `Chuyện rằng năm tháng cứ trôi chẳng thấy quay lại` },
        { start: 172, end: 177, text: `Tại sao anh vẫn đau khi nhìn thấy em bên ai` },
        { start: 177, end: 180, text: `Liệu rằng câu hát anh yêu em` },
        { start: 180, end: 183, text: `Sẽ đến bên em` },
        { start: 183, end: 188, text: `Khi đêm ùa vào ôm chặt em` },
        { start: 188, end: 191, text: `Ngập ngừng lời yêu la la love` },
        { start: 191, end: 196, text: `Có phải quá trễ để trao về em không la la love` },
        { start: 196, end: 201, text: `Có phải tiếng khóc cô đơn vì em la la love` },
        { start: 201, end: 208, text: `Đã đến lúc hát lên câu ca này` },
        { start: 208, end: 211, text: `Ngập ngừng lời yêu la la love` },
        { start: 211, end: 217, text: `Chẳng thể quá trễ để trao về em đâu la la love` },
        { start: 217, end: 221, text: `Chẳng còn tiếng khóc cô đơn vì em la la love` },
        { start: 221, end: 227, text: `Đã đến lúc hát lên câu ca này` },
        { start: 227, end: 232, text: `Chuyện rằng huh huh huh huh mơ màng` },
        { start: 232, end: 237, text: `Anh trao yêu dấu trong anh từng phút yên bình` },
        { start: 237, end: 241, text: `Để từng câu hát anh yêu em` },
        { start: 241, end: 245, text: `Sẽ đến bên em` },
        { start: 245, end: 247, text: `Khi đêm đen về` },
        { start: 247, end: 252, text: `Chuyện rằng năm tháng cứ trôi chẳng thấy quay lại` },
        { start: 252, end: 257, text: `Và chẳng hối tiếc khi có nhìn thấy em bên ai` },
        { start: 257, end: 261, text: `Để từng câu hát anh yêu em` },
        { start: 261, end: 263, text: `Sẽ đến bên em` },
        { start: 263, end: 268, text: `Khi đêm ùa vào ôm chặt em` },
        { start: 268, end: 278, text: `Oh I'm just a boy` },
    ],
    vaicaunoicokhiennguoithaydoi: [
        { start: 22, end: 27, text: `Thức thâu đêm để nghĩ suy về em nhiều` },
        { start: 27, end: 29, text: `Thật ra có những điều` },
        { start: 29, end: 33, text: `Làm cho anh không yên được giấc` },
        { start: 33, end: 38, text: `Bấy lâu ta không nói nhau một câu nào` },
        { start: 38, end: 41, text: `Chờ dòng tin nhắn chào` },
        { start: 41, end: 44, text: `Trở lại cảm giác như lúc trước` },
        { start: 44, end: 47, text: `Có phải vì anh` },
        { start: 47, end: 49, text: `Vẫn thường vô ý` },
        { start: 49, end: 55, text: `Chẳng suy nghĩ, vài lần khiến em u sầu` },
        { start: 55, end: 58, text: `Có phải vì anh` },
        { start: 58, end: 60, text: `Trót vài câu nói` },
        { start: 60, end: 66, text: `Chạm vào nơi niềm đau mà người luôn chôn giấu` },
        { start: 66, end: 70, text: `Vài câu nói có khiến người thay đổi?` },
        { start: 70, end: 73, text: `Có khiến bờ môi ấm êm?` },
        { start: 73, end: 77, text: `Nay chỉ còn trong nỗi nhớ` },
        { start: 77, end: 81, text: `Vài câu nói kéo đến màu u tối` },
        { start: 81, end: 86, text: `Cuốn hết bình yên lúc xưa bên cạnh nhau` },
        { start: 86, end: 93, text: `Mãi đi xa để mình ta trong căn phòng` },
        { start: 93, end: 99, text: `Cùng nước mắt trong lòng` },
        { start: 99, end: 100, text: `Yeah` },
        { start: 100, end: 103, text: `Chẳng còn giọt nước mắt nào cho em rơi` },
        { start: 103, end: 105, text: `Cũng chẳng còn gì tha thiết để nói nên lời` },
        { start: 105, end: 108, text: `Sẽ chỉ mang đến thêm u sầu` },
        { start: 108, end: 109, text: `Làm dấu yêu phai màu` },
        { start: 109, end: 112, text: `Chẳng biết ta phải đi về đâu` },
        { start: 112, end: 113, text: `Giờ thì lời xin lỗi còn kịp thời?` },
        { start: 113, end: 116, text: `Làm sao khi cảm xúc em nguội rồi?` },
        { start: 116, end: 118, text: `Bao nhiêu lần như thế rồi` },
        { start: 118, end: 120, text: `Không còn cơ hội nào cho anh nữa đâu` },
        { start: 120, end: 121, text: `Tổn thương nhau bấy nhiêu đây thôi` },
        { start: 121, end: 124, text: `Có phải vì anh (cũng tại vì anh)` },
        { start: 124, end: 126, text: `Vẫn thường vô ý` },
        { start: 126, end: 128, text: `Làm em rối trí` },
        { start: 128, end: 130, text: `Ngày đêm tối nghĩ suy` },
        { start: 130, end: 133, text: `Vậy mà người vô tâm nào biết gì đâu` },
        { start: 133, end: 135, text: `Có phải vì anh (vì anh)` },
        { start: 135, end: 138, text: `Trót vài câu nói` },
        { start: 138, end: 143, text: `Chạm vào nơi niềm đau mà người luôn chôn giấu` },
        { start: 143, end: 147, text: `Vài câu nói có khiến người thay đổi?` },
        { start: 147, end: 150, text: `Có khiến bờ môi ấm êm?` },
        { start: 150, end: 154, text: `Nay chỉ còn trong nỗi nhớ (còn trong nỗi nhớ)` },
        { start: 154, end: 158, text: `Vài câu nói kéo đến màu u tối` },
        { start: 158, end: 163, text: `Cuốn hết bình yên lúc xưa bên cạnh nhau` },
        { start: 163, end: 168, text: `Mãi đi xa để mình ta trong căn phòng (trong căn phòng)` },
        { start: 168, end: 174, text: `Vì dòng cảm xúc không thể trở về như lúc ta vừa bắt đầu` },
        { start: 174, end: 179, text: `Và sẽ như thế nào nếu bỏ lại ngày tháng đã từng với nhau?` },
        { start: 179, end: 185, text: `Một vài câu nói vô tình đẩy lùi mọi thứ về thì quá khứ` },
        { start: 185, end: 193, text: `Baby I just wanna say I'm sorry` },
        { start: 198, end: 206, text: `Mình ta trong căn phòng` },
    ],
    'giac-mo-dep': [
        { start: 10, end: 12, text: `Nghèo giàu sang do số` },
        { start: 12, end: 15, text: `Nhân duyên do trời` },
        { start: 15, end: 16, text: `Không trông mong chi` },
        { start: 16, end: 19, text: `Hơn ngoài cuộc sống bình yên` },
        { start: 19, end: 22, text: `Dù người đời vẫn hay cố` },
        { start: 22, end: 24, text: `Yêu đương xa vời` },
        { start: 24, end: 26, text: `Dẫu nhân gian cô đơn` },
        { start: 26, end: 29, text: `Đâu chỉ có mình tôi` },
        { start: 29, end: 32, text: `Một ngày em bước tới đây` },
        { start: 32, end: 34, text: `Mang theo đôi lời` },
        { start: 34, end: 36, text: `Yêu anh thương anh` },
        { start: 36, end: 38, text: `Em chỉ cần có vậy thôi` },
        { start: 38, end: 41, text: `Dịu dàng em đưa lối` },
        { start: 41, end: 43, text: `Băng qua núi đồi` },
        { start: 43, end: 46, text: `Tôi như mơ chiêm bao` },
        { start: 46, end: 47, text: `Tôi si mê em` },
        { start: 47, end: 49, text: `Và tình yêu đó` },
        { start: 49, end: 51, text: `Đã xua đi mây mờ` },
        { start: 51, end: 54, text: `Để mùa hè năm đó` },
        { start: 54, end: 57, text: `Đã đến như giấc mơ` },
        { start: 57, end: 59, text: `Ngày còn thơ bé` },
        { start: 59, end: 61, text: `Hằng đêm anh mong chờ` },
        { start: 61, end: 63, text: `Được đùa cùng tia nắng` },
        { start: 63, end: 65, text: `Được hát dưới ánh trăng` },
        { start: 65, end: 66, text: `La lá la` },
        { start: 66, end: 68, text: `Giờ thì mơ ước` },
        { start: 68, end: 70, text: `Đã ngay bên kia bờ` },
        { start: 70, end: 73, text: `Còn chờ gì em hỡi` },
        { start: 73, end: 76, text: `Mà chẳng đến ghé chơi` },
        { start: 76, end: 78, text: `Kệ ngày mai tới` },
        { start: 78, end: 80, text: `Kệ mưa giông cuộc đời` },
        { start: 80, end: 83, text: `Mà chỉ cần em hứa` },
        { start: 83, end: 87, text: `Là sẽ mãi ở bên` },
        { start: 87, end: 90, text: `Đưa nhau băng qua ngọn đồi xanh` },
        { start: 90, end: 92, text: `Một bờ cát trắng trong lành` },
        { start: 92, end: 95, text: `Khoảng trời riêng có em và anh` },
        { start: 95, end: 97, text: `Cần gì hơn đôi tay em` },
        { start: 97, end: 99, text: `Tô màu thiên thanh` },
        { start: 99, end: 102, text: `Cùng đàn chim hót trên cành` },
        { start: 102, end: 103, text: `Thì thầm bao lời yêu` },
        { start: 103, end: 105, text: `Ấm áp thiết tha` },
        { start: 105, end: 107, text: `Và tình yêu đó` },
        { start: 107, end: 109, text: `Đã xua đi mây mờ` },
        { start: 109, end: 111, text: `Để mùa hè năm đó` },
        { start: 111, end: 114, text: `Đã đến như giấc mơ` },
        { start: 114, end: 116, text: `Ngày còn thơ bé` },
        { start: 116, end: 119, text: `Hằng đêm anh mong chờ` },
        { start: 119, end: 121, text: `Được đùa cùng tia nắng` },
        { start: 121, end: 123, text: `Được hát dưới ánh trăng` },
        { start: 123, end: 124, text: `La lá la` },
        { start: 124, end: 126, text: `Giờ thì mơ ước` },
        { start: 126, end: 128, text: `Đã ngay bên kia bờ` },
        { start: 128, end: 131, text: `Còn chờ gì em hỡi` },
        { start: 131, end: 134, text: `Mà chẳng đến ghé chơi` },
        { start: 134, end: 136, text: `Kệ ngày mai tới` },
        { start: 136, end: 138, text: `Kệ mưa giông cuộc đời` },
        { start: 138, end: 140, text: `Mà chỉ cần em hứa` },
        { start: 140, end: 148, text: `Là sẽ mãi ở bên` },
        { start: 157, end: 159, text: `Mà chỉ cần em hứa` },
        { start: 159, end: 163, text: `Là sẽ mãi ở bên` },
        { start: 163, end: 166, text: `Ngày vẫn trôi như thế` },
        { start: 166, end: 168, text: `Riêng mình tôi vẫn chờ` },
        { start: 168, end: 170, text: `Đợi chờ em về đây` },
        { start: 170, end: 173, text: `Vui đùa cùng với gió mây` },
        { start: 173, end: 175, text: `Đời vẫn trôi như thế` },
        { start: 175, end: 178, text: `Phiêu dạt vô bến bờ` },
        { start: 178, end: 181, text: `Vì chẳng có nơi đâu` },
        { start: 181, end: 186, text: `Tìm thấy nhau` },
    ],
    'tinh-yeu-ngu-quen': [
        { start: 9, end: 18, text: `Nana nana nana` },
        { start: 18, end: 23, text: `Dù em đã cố gắng cho tình yêu ngủ quên` },
        { start: 23, end: 27, text: `Giả vờ như anh không có mặt ở nơi kế bên` },
        { start: 27, end: 32, text: `Mà con tim vẫn cứ ba-da-boom mỗi khi` },
        { start: 32, end: 39, text: `Mình trao nhau ánh mắt thâm sâu đê mê ôi anh làm em say mềm` },
        { start: 39, end: 42, text: `Đêm về khuya và anh đang lặng thinh` },
        { start: 42, end: 48, text: `Ngồi nhìn em nói anh mê chữ ê kéo dài` },
        { start: 48, end: 52, text: `Em là Queen ở trên Instagram` },
        { start: 52, end: 56, text: `Cảm ơn ba má em vì đã thật khéo tay` },
        { start: 56, end: 58, text: `You’re a little piece of art` },
        { start: 58, end: 60, text: `Em như kiệt tác` },
        { start: 60, end: 62, text: `Luôn chú tâm vào em anh không thể làm việc khác` },
        { start: 62, end: 63, text: `Suy tư nhiều đêm` },
        { start: 63, end: 64, text: `Henny nhiều thêm` },
        { start: 64, end: 68, text: `Baby fooling around me cuz anh có nhiều fame` },
        { start: 68, end: 70, text: `Playing game không cần thiết đâu` },
        { start: 70, end: 72, text: `Ta yêu nhau nên xin đừng giết nhau` },
        { start: 72, end: 75, text: `Hãy cứ cùng nhau và đêm này ta thả trôi` },
        { start: 75, end: 80, text: `Dù em đã cố gắng cho tình yêu ngủ quên` },
        { start: 80, end: 85, text: `Giả vờ như anh không có mặt ở nơi kế bên` },
        { start: 85, end: 90, text: `Mà con tim vẫn cứ ba-da-boom mỗi khi` },
        { start: 90, end: 96, text: `Mình trao nhau ánh mắt thâm sâu đê mê ôi anh làm em say mềm` },
        { start: 96, end: 99, text: `Dẫu vẫn biết em ok khi em một mình` },
        { start: 99, end: 101, text: `Em đã trải qua đôi ba cuộc tình` },
        { start: 101, end: 105, text: `Em có thể tin anh khi em nói ra hết những bí mật của em` },
        { start: 105, end: 108, text: `Ta sẽ cùng giúp nhau hàn gắn bao tổn thương` },
        { start: 108, end: 110, text: `Lau khô giọt nước mắt mà đôi mi còn vương` },
        { start: 110, end: 113, text: `Hôn nhau ở trên xe khi kính phủ mờ sương` },
        { start: 113, end: 115, text: `Imma get it right` },
        { start: 115, end: 116, text: `Brand new ride` },
        { start: 116, end: 117, text: `Em yêu ai` },
        { start: 117, end: 120, text: `Post cái thử lên Face xem là bao nhiêu like` },
        { start: 120, end: 122, text: `Khi em high thì em so fly` },
        { start: 122, end: 125, text: `Nếu muốn giữ lại khoảnh khắc này thì anh đâu sai` },
        { start: 125, end: 126, text: `Thôi anh đùa đấy` },
        { start: 126, end: 127, text: `Ai mà không thấy` },
        { start: 127, end: 129, text: `Bao lần say cùng nhau thì anh đều lưu hình trong máy` },
        { start: 129, end: 133, text: `Giữ cho mình anh cho mình anh mà thôi` },
        { start: 133, end: 138, text: `Dù em đã cố gắng cho tình yêu ngủ quên (ngủ quên babe)` },
        { start: 138, end: 143, text: `Giả vờ như anh không có mặt ở nơi kế bên` },
        { start: 143, end: 147, text: `Mà con tim vẫn cứ ba-da-boom mỗi khi (mỗi khi ta bên nhau)` },
        { start: 147, end: 155, text: `Mình trao nhau ánh mắt thâm sâu đê mê ôi anh làm em say mềm` },
        { start: 155, end: 163, text: `Hoh woh huh` },
        { start: 163, end: 173, text: `Nana nana nana` },
    ],
    'chay-khoi-the-gioi-nay': [
        { start: 15, end: 18, text: `Nắm lấy tay em kệ những nỗi đau` },
        { start: 18, end: 21, text: `Đôi chân chạy nhanh băng qua bao núi cao vực sâu` },
        { start: 21, end: 25, text: `Xung quanh như phủ kín bóng đêm, sa mạc đã khoác lên` },
        { start: 25, end: 28, text: `Một trời u tối khiến ta bỗng chốc như lạc lối` },
        { start: 28, end: 31, text: `Ta sẽ không buông tay cho dù mai` },
        { start: 31, end: 35, text: `Mặt trời rồi chẳng lên chiếu sáng đoạn đường không bóng ai` },
        { start: 35, end: 37, text: `Em sẽ luôn kề bên anh` },
        { start: 37, end: 41, text: `Cùng anh chạy khỏi thế giới này` },
        { start: 41, end: 45, text: `Và Trái Đất hóa thành những giấc mơ êm` },
        { start: 45, end: 49, text: `Chỉ cần được đi bên em mỗi đêm` },
        { start: 49, end: 55, text: `Phía trước con đường kia dù trời giông tố mây đen kéo về` },
        { start: 55, end: 59, text: `Chỉ cần có anh cầm chặt tay em` },
        { start: 59, end: 62, text: `Đưa em bay vào những khung trời bình yên` },
        { start: 62, end: 65, text: `Và ngàn nỗi đau sẽ tan biến mau` },
        {
            start: 65,
            end: 69,
            text: `Chạy thoát ra khỏi nơi đây anh cùng em đến những vùng trời trôi theo áng mây`,
        },
        { start: 69, end: 72, text: `Cùng giơ cánh tay, tưởng tượng rằng mình tung cánh bay` },
        { start: 72, end: 75, text: `Đừng chần chờ hãy tới đây cùng anh mình chạy khỏi thế giới này` },
        { start: 75, end: 77, text: `Bỏ hết sau lưng những nỗi âu lo` },
        { start: 77, end: 79, text: `Gạt hết suy tư, vấn vương, so đo` },
        { start: 79, end: 82, text: `Mặc kệ nơi cuộc sống ai kia đổi thay` },
        { start: 82, end: 86, text: `Và cùng tìm về một nơi xa, bay cùng gió` },
        { start: 86, end: 90, text: `Mãi mãi là anh, yêu em không lý do` },
        { start: 90, end: 97, text: `Anh sẽ luôn kề bên em, chạy về phía bên kia bầu trời` },
        { start: 97, end: 100, text: `Nắm lấy tay em kệ những nỗi đau` },
        { start: 100, end: 103, text: `Đôi chân chạy nhanh băng qua bao núi cao vực sâu` },
        { start: 103, end: 107, text: `Xung quanh như phủ kín bóng đêm, sa mạc đã khoác lên` },
        { start: 107, end: 110, text: `Một trời u tối khiến ta bỗng chốc như lạc lối` },
        { start: 110, end: 114, text: `Ta sẽ không buông tay cho dù mai` },
        { start: 114, end: 117, text: `Mặt trời rồi chẳng lên chiếu sáng đoạn đường không bóng ai` },
        { start: 117, end: 119, text: `Em sẽ luôn kề bên anh` },
        { start: 119, end: 125, text: `Cùng anh chạy khỏi thế giới này` },
        { start: 125, end: 126, text: `Mỗi khi anh đang thấy chán` },
        { start: 126, end: 128, text: `Em ở với anh chỉ yên lặng có được không?` },
        { start: 128, end: 129, text: `Đưa ra bàn tay nhỏ xinh để anh bám` },
        { start: 129, end: 131, text: `Để anh không thấy như chìm sâu dưới biển rộng` },
        { start: 131, end: 133, text: `Bên ngoài cửa sổ cảnh vật đi ngang qua` },
        { start: 133, end: 134, text: `Bên trong thế giới chỉ của riêng hai ta` },
        {
            start: 134,
            end: 138,
            text: `Chẳng cần để ý rằng con phố cũ ngày nào vẫn ồn ào hôm nay sẽ đưa mình đi bao xa`,
        },
        { start: 138, end: 140, text: `Bên em từng phút với anh là vàng là ngọc` },
        { start: 140, end: 142, text: `Kiếp người phù vân, còn nhân sinh là mộng` },
        { start: 142, end: 143, text: `Mọi thứ sẽ qua, còn hai chúng ta` },
        { start: 143, end: 145, text: `Chạy trốn thế giới qua đường ngang sang đường dọc` },
        { start: 145, end: 146, text: `Ở bên cạnh nhau khi thế giới này sau lưng` },
        { start: 146, end: 148, text: `Nắm chặt tay nhau cho đến khi Trái Đất dừng` },
        { start: 148, end: 150, text: `Anh không quan tâm nếu bão dông nay chưa ngưng` },
        { start: 150, end: 152, text: `Vì anh đã có nắng ấm trong mắt nâu em chứa đựng, ya` },
        { start: 152, end: 158, text: `Anh sẽ nhắc em nhớ đến những cơn mơ em đã từng chờ` },
        { start: 158, end: 166, text: `Vì đời cuốn trôi, ta đi biết đâu ai ngờ (cuốn trôi ta đi)` },
        { start: 166, end: 172, text: `Ta sẽ nhắc nhau nhớ, ta sẽ không quên lý do tồn tại` },
        { start: 172, end: 180, text: `Tựa vào vai anh, ta trốn khỏi thế giới này` },
        { start: 207, end: 210, text: `Nắm lấy tay em kệ những nỗi đau` },
        { start: 210, end: 213, text: `Đôi chân chạy nhanh băng qua bao núi cao vực sâu` },
        { start: 213, end: 217, text: `Xung quanh như phủ kín bóng đêm, sa mạc đã khoác lên` },
        { start: 217, end: 220, text: `Một trời u tối khiến ta bỗng chốc như lạc lối` },
        { start: 220, end: 224, text: `Ta sẽ không buông tay cho dù mai` },
        { start: 224, end: 227, text: `Mặt trời rồi chẳng lên chiếu sáng đoạn đường không bóng ai` },
        { start: 227, end: 229, text: `Em sẽ luôn kề bên anh` },
        { start: 229, end: 234, text: `Cùng anh chạy khỏi thế giới này` },
        {
            start: 234,
            end: 240,
            text: `Nắm lấy tay anh, cùng nhau đi qua bao vực sâu (đã từng có những ngày cả thế giới đều như đang chống lại anh)`,
        },
        { start: 240, end: 242, text: `(Nhưng khi nhìn lại, đều luôn có em ở bên)` },
        { start: 242, end: 246, text: `Sẽ luôn bên em, chạy khỏi thế giới này (nắm chặt đôi bàn tay anh, hmm)` },
        { start: 246, end: 254, text: `(Đó là lúc anh biết, rồi mọi thứ sẽ ổn thôi, yeah)` },
    ],
    'anh-sao-va-bau-troi': [
        { start: 30, end: 38, text: `Chưa bao giờ tôi thấy, em cười nhiều như hôm nay` },
        { start: 38, end: 45, text: `Chưa bao giờ tôi thấy, mắt em long lanh thế này` },
        { start: 45, end: 51, text: `Em say mê nói về anh ta, về cuộc hẹn hò ngày hôm qua` },
        { start: 51, end: 57, text: `Người mà luôn làm em ngạc nhiên với những món quà` },
        { start: 57, end: 64, text: `Ngỡ như rằng mình sẽ vui, khi em nói có người mới` },
        { start: 64, end: 71, text: `Thế nhưng trong lòng chơi vơi, con tim vỡ ra thành trăm mảnh rồi` },
        { start: 71, end: 78, text: `Chỉ là một giây buông tay, giờ đành lỡ nhau, cả một đời` },
        { start: 78, end: 84, text: `Em có thêm một ánh sao, tôi mất bầu trời` },
        { start: 84, end: 88, text: `Muốn nói tôi vẫn còn yêu (em)` },
        { start: 88, end: 91, text: `Muốn giữ lấy đôi bờ vai (em)` },
        { start: 91, end: 98, text: `Muốn nói em ơi đừng đi, đừng đi về nơi có anh ta đang đứng chờ` },
        { start: 98, end: 101, text: `Muốn nắm tay em một lần (nữa)` },
        { start: 101, end: 105, text: `Cùng quay về lại con phố (xưa)` },
        { start: 105, end: 113, text: `Nụ hôn đầu tiên mình trao dưới mưa em đã quên chưa?` },
        { start: 141, end: 143, text: `Em, em đừng bao giờ khóc` },
        { start: 143, end: 148, text: `Hãy hạnh phúc nhé xin đừng khóc sẽ có người luôn làm em mỉm cười` },
        { start: 148, end: 150, text: `Còn điều gì đọng lại ở tim anh` },
        { start: 150, end: 155, text: `Dù mọi chuyện giờ đã qua nhanh anh sẽ cố giữ cố giữ` },
        { start: 155, end: 157, text: `Dù rất muốn nói ra` },
        { start: 157, end: 163, text: `Anh rất nhớ em đêm ngày chẳng thể nào ngủ được` },
        { start: 163, end: 166, text: `I really really miss you babe` },
        { start: 166, end: 174, text: `Ngỡ như rằng mình sẽ vui, khi em nói có người mới` },
        { start: 174, end: 181, text: `Thế nhưng trong lòng chơi vơi, con tim vỡ ra thành trăm mảnh rồi` },
        { start: 181, end: 188, text: `Chỉ là một giây buông tay, giờ đành lỡ nhau, cả một đời` },
        { start: 188, end: 194, text: `Em có thêm một ánh sao, tôi mất bầu trời` },
        { start: 194, end: 198, text: `Muốn nói tôi vẫn còn yêu (em)` },
        { start: 198, end: 201, text: `Muốn giữ lấy đôi bờ vai (em)` },
        { start: 201, end: 208, text: `Muốn nói em ơi đừng đi, đừng đi về nơi có anh ta đang đứng chờ` },
        { start: 208, end: 211, text: `Muốn nắm tay em một lần (nữa)` },
        { start: 211, end: 215, text: `Cùng quay về lại con phố (xưa)` },
        { start: 215, end: 223, text: `Nụ hôn đầu tiên mình trao dưới mưa em đã quên chưa?` },
        { start: 223, end: 230, text: `Mong cho em luôn vui và cười như lúc này` },
        { start: 230, end: 234, text: `Dù anh sẽ chẳng ở mãi bên em` },
        { start: 234, end: 237, text: `Vì giờ đã có người thay thế anh` },
        { start: 237, end: 242, text: `Xin người kia sẽ chẳng để lệ rơi mắt em` },
        { start: 242, end: 250, text: `Sẽ luôn thật quan tâm em` },
    ],
    tim: [
        { start: 16, end: 19, text: `Chiều hoàng hôn buông đang dần phai` },
        { start: 19, end: 20, text: `Cô đơn lang thang` },
        { start: 20, end: 23, text: `Trôi qua hết tháng ngày dài` },
        { start: 23, end: 25, text: `Khi trong thâm tâm ta luôn biết` },
        { start: 25, end: 28, text: `Chẳng có ai kề sát vai` },
        { start: 28, end: 33, text: `Mỗi khi buồn vui đau đớn gì` },
        { start: 33, end: 36, text: `Cuộc đời đã cho tôi niềm tin` },
        { start: 36, end: 38, text: `Nhưng đôi khi mang luôn đi hết` },
        { start: 38, end: 40, text: `Chẳng giữ gì` },
        { start: 40, end: 42, text: `Lặng thầm nhìn về một hình bóng` },
        { start: 42, end: 45, text: `Đã xa rồi, đã xa rồi` },
        { start: 45, end: 50, text: `Để mình tôi lạnh đôi môi nhạt nhòa thôi` },
        { start: 50, end: 52, text: `Rồi một mùa thu đã dần qua` },
        { start: 52, end: 55, text: `Đông đến cùng ta` },
        { start: 55, end: 56, text: `Mang những lạnh giá` },
        { start: 56, end: 58, text: `Vì một người ra đi vội vã` },
        { start: 58, end: 61, text: `Để tôi đi tìm` },
        { start: 61, end: 67, text: `Trong đêm tôi vẫn đi tìm` },
        { start: 67, end: 69, text: `Tìm hoài để thấy thấy` },
        { start: 69, end: 74, text: `Để để thấy được tình yêu ấy ấy` },
        { start: 74, end: 78, text: `Mãi vẫn mãi luôn còn trong tim này` },
        { start: 78, end: 83, text: `Những ký ức ấy vẫn trong tim này` },
        { start: 83, end: 88, text: `Dù lòng vẫn biết biết biết vẫn biết` },
        { start: 88, end: 89, text: `Ai chẳng hề nhớ` },
        { start: 89, end: 95, text: `Nhớ nhớ nhớ đến yêu thương bao giờ` },
        { start: 95, end: 101, text: `Nhưng con tim ấy vẫn luôn mong chờ` },
        { start: 101, end: 104, text: `Ánh sáng xung quanh dần mờ` },
        { start: 104, end: 106, text: `Có một người ngồi thẫn thơ` },
        { start: 106, end: 108, text: `Nhớ nhớ nhung nhung đợi chờ` },
        { start: 108, end: 110, text: `Với những hi vọng dù nhỏ bé` },
        { start: 110, end: 112, text: `Nhưng vẫn sẽ` },
        { start: 112, end: 114, text: `Hóa thành đôi cánh của loài chim` },
        { start: 114, end: 117, text: `Bay vút lên cao` },
        { start: 117, end: 120, text: `Lặng thầm ôm bao yêu thương` },
        { start: 120, end: 121, text: `Lang thang đại dương đi kiếm tìm` },
        { start: 121, end: 123, text: `Càng vào sâu trong tâm tư` },
        { start: 123, end: 124, text: `Em mới biết rằng` },
        { start: 124, end: 129, text: `Em đang đắm chìm trong quá khứ` },
        { start: 129, end: 132, text: `Còn nhiều điều em muốn giữ` },
        { start: 132, end: 136, text: `Mà chẳng biết đang ở đâu` },
        { start: 136, end: 140, text: `Chờ một cuộc tình đã mất từ lâu` },
        { start: 140, end: 145, text: `Chờ một kỉ niệm đã lỡ nhạt màu` },
        { start: 145, end: 146, text: `Còn lại điều gì` },
        { start: 146, end: 149, text: `Khi kí ức đã vỡ tan` },
        { start: 149, end: 153, text: `Heh yeah ih yeah ih yeah ih yeah` },
        { start: 153, end: 157, text: `Từng ngày từng ngày trống vắng quạnh hiu` },
        { start: 157, end: 161, text: `Lòng còn ngập tràn mênh mang nỗi nhớ` },
        { start: 161, end: 162, text: `Để rồi vẫn thấy` },
        { start: 162, end: 166, text: `Luôn chơ vơ ta với ta` },
        { start: 166, end: 176, text: `Heh eh yeah eh yeah eh yeah` },
        { start: 176, end: 179, text: `Tìm hoài để thấy thấy` },
        { start: 179, end: 183, text: `Để để thấy được tình yêu ấy ấy` },
        { start: 183, end: 188, text: `Mãi vẫn mãi luôn còn trong tim này` },
        { start: 188, end: 193, text: `Những ký ức ấy vẫn trong tim này` },
        { start: 193, end: 197, text: `Dù lòng vẫn biết biết biết vẫn biết` },
        { start: 197, end: 200, text: `Ai chẳng hề nhớ` },
        { start: 200, end: 204, text: `Nhớ nhớ nhớ đến yêu thương bao giờ` },
        { start: 204, end: 210, text: `Nhưng con tim ấy vẫn luôn mong chờ` },
        { start: 210, end: 218, text: `Chờ ai hoo uh yeah` },
        { start: 218, end: 226, text: `Chờ ai` },
    ],
    'lac-vao-trong-mo': [
        { start: 15, end: 17, text: `Anh lạc vào trong mơ` },
        { start: 17, end: 19, text: `Thấy em ở trong đó` },
        { start: 19, end: 23, text: `Định chạm vào bờ môi gió nhưng khi gần kề em biến mất` },
        { start: 23, end: 26, text: `Baby can you kiss me` },
        { start: 26, end: 28, text: `Ở sâu trong tâm trí` },
        { start: 28, end: 32, text: `Bàn tay em sát bên anh anh có thể nắm được chặt lấy` },
        { start: 32, end: 36, text: `Nếu đây là giấc mơ thì hãy để anh chìm thật sâu` },
        { start: 36, end: 40, text: `Anh không muốn thức dậy để lỡ vụt mất em nữa đâu` },
        { start: 40, end: 44, text: `Nếu em có giống anh thì hãy đưa tay chạm vào nhau` },
        { start: 44, end: 48, text: `Vì anh tin phép nhiệm màu rồi biến giấc mơ thành sự thật` },
        { start: 48, end: 51, text: `Can baby kiss me more` },
        { start: 51, end: 53, text: `Kiss me more` },
        { start: 53, end: 55, text: `Can baby kiss me more` },
        { start: 55, end: 57, text: `Kiss me more` },
        { start: 57, end: 59, text: `Can baby kiss me more` },
        { start: 59, end: 61, text: `Kiss me more` },
        { start: 61, end: 64, text: `Can baby kiss me more` },
        { start: 64, end: 66, text: `Kiss me more` },
        { start: 66, end: 68, text: `Yah ửng hồng tình yêu chỉ trong vài phút` },
        { start: 68, end: 71, text: `Chớm tắt cuộc tình chỉ trong vài giây` },
        { start: 71, end: 73, text: `Đi ngang tâm trí trong một thoáng chốc` },
        { start: 73, end: 75, text: `Đem lại tương tư tim say ngất ngây` },
        { start: 75, end: 77, text: `Nhắc đến tươi tắn nhớ đến môi em` },
        { start: 77, end: 79, text: `Nhắc đến ánh nắng nhớ đến nụ cười` },
        { start: 79, end: 81, text: `Nhắc đến ấm áp nhớ đôi tay ấy` },
        { start: 81, end: 83, text: `Mỗi buổi chiều đông ấm cả vai gầy` },
        { start: 83, end: 85, text: `Đi vòng dạo quanh em không cần váy ngắn` },
        { start: 85, end: 87, text: `Anh không cần SH vẫn ấm không cần chăn` },
        { start: 87, end: 89, text: `Bụng ta vẫn căng tròn ta không cần nhà hàng` },
        { start: 89, end: 91, text: `Nụ cười em vẫn hé cạnh quán bán bánh tráng` },
        { start: 91, end: 93, text: `Ta yêu không cầu kì từ đơn giản nhất` },
        { start: 93, end: 95, text: `Yêu từ cách nhìn đến mái tóc em phảng phất` },
        { start: 95, end: 97, text: `Anh cho một lí do em bỏ màu son môi` },
        { start: 97, end: 98, text: `Em cho một câu nói tóc anh đổi màu thật` },
        { start: 98, end: 102, text: `Nếu đây là giấc mơ thì hãy để anh chìm thật sâu` },
        { start: 102, end: 107, text: `Anh không muốn thức dậy để lỡ vụt mất em nữa đâu` },
        { start: 107, end: 111, text: `Nếu em có giống anh thì hãy đưa tay chạm vào nhau` },
        { start: 111, end: 115, text: `Vì anh tin phép nhiệm màu sẽ biến giấc mơ thành sự thật` },
        { start: 115, end: 118, text: `Ở trong mơ anh thấy em thật yêu kiều` },
        { start: 118, end: 122, text: `Lướt qua bao chàng trai đến bên nắm tay anh trao nụ hôn nhẹ` },
        { start: 122, end: 126, text: `Khẽ đưa ánh mắt chạm nhau` },
        { start: 126, end: 131, text: `Từng câu môi gọi mời xuyến xao` },
        { start: 131, end: 136, text: `Lảng tránh đi những câu đùa nửa thật em làm anh đau` },
        { start: 136, end: 140, text: `Anh cố gắng gượng cười để che đi nỗi buồn tim sâu` },
        { start: 140, end: 144, text: `Nếu em có yêu anh thì trả lời anh để yêu lâu` },
        { start: 144, end: 148, text: `Em đừng cười như thế là tim của anh bị slowmo` },
        { start: 148, end: 151, text: `Can baby kiss me more` },
        { start: 151, end: 152, text: `Kiss me more` },
        { start: 152, end: 155, text: `Can baby kiss me more` },
        { start: 155, end: 156, text: `Kiss me more` },
        { start: 156, end: 159, text: `Can baby kiss me more` },
        { start: 159, end: 160, text: `Kiss me more` },
        { start: 160, end: 163, text: `Can baby kiss me more` },
        { start: 163, end: 170, text: `Kiss me more` },
    ],
    'phai-long-anh': [
        { start: 11, end: 18, text: `Chẳng còn champagne, mọi người đang say, bữa tiệc đã tàn` },
        {
            start: 18,
            end: 24,
            text: `Chỉ còn hai ta, lặng yên bên nhau, phút giây nhẹ nhàng (phút giây nhẹ nhàng)`,
        },
        { start: 24, end: 30, text: `Từng ngày đi qua mình luôn coi nhau vẫn như là bạn (vẫn như là bạn)` },
        { start: 30, end: 36, text: `Vậy mà sao giờ đây, anh đang nhìn em bằng ánh mắt đắm say như vậy` },
        { start: 36, end: 39, text: `Ta đang cố gắng trốn tránh điều gì về nhau?` },
        { start: 39, end: 42, text: `Ta đang cố gắng níu kéo điều gì về nhau?` },
        { start: 42, end: 47, text: `Ta đang mong được nói hết điều gì đậm sâu?` },
        { start: 47, end: 53, text: `Và từng đêm em mơ, em mơ, em mơ, em mơ như thế` },
        { start: 53, end: 56, text: `Từng cảm xúc cứ chiếm lấy em` },
        { start: 56, end: 59, text: `Từng nhịp trái tim cứ nóng lên` },
        { start: 59, end: 65, text: `Và em biết không nên, không nên, không nên, không nên như thế (uhm)` },
        { start: 65, end: 68, text: `Vì thật khó để giữ lấy anh` },
        { start: 68, end: 78, text: `Vì thật khó cho em nếu như phải lòng anh` },
        { start: 78, end: 84, text: `Làm sao anh có thể làm cho em đắm say đến vậy? (Đắm say đến vậy)` },
        { start: 84, end: 90, text: `Làm sao em có thể chôn giấu hết những cảm xúc này?` },
        { start: 90, end: 93, text: `Làm sao ta biết rằng ta đang sai` },
        { start: 93, end: 96, text: `Và ta có nên dừng lại?` },
        { start: 96, end: 102, text: `Vậy mà sao giờ đây, anh đang nhìn em bằng ánh mắt đắm say như vậy?` },
        { start: 102, end: 105, text: `Ta đang cố gắng trốn tránh điều gì về nhau?` },
        { start: 105, end: 108, text: `Ta đang cố gắng níu kéo điều gì về nhau?` },
        { start: 108, end: 113, text: `Ta đang mong được nói hết điều gì đậm sâu?` },
        {
            start: 113,
            end: 119,
            text: `Và từng đêm em mơ, em mơ, em mơ, em mơ như thế (I'm dreaming 'bout you, I'm dreaming 'bout you, ah ah)`,
        },
        { start: 119, end: 122, text: `Từng cảm xúc cứ chiếm lấy em` },
        { start: 122, end: 125, text: `Từng nhịp trái tim cứ nóng lên` },
        {
            start: 125,
            end: 131,
            text: `Và em biết không nên, không nên, không nên, không nên như thế (I shouldn't love you, I shouldn't love you, ah ah)`,
        },
        { start: 131, end: 134, text: `Vì thật khó để giữ lấy anh` },
        { start: 134, end: 138, text: `Vì thật khó cho em nếu như phải lòng anh` },
        { start: 138, end: 144, text: `Nếu không là bây giờ, sẽ không là bao giờ` },
        { start: 144, end: 150, text: `Mãi một đời mong chờ, một giấc mơ (I shouldn't love you)` },
        { start: 150, end: 156, text: `Nếu không là bây giờ, sẽ không là bao giờ` },
        { start: 156, end: 164, text: `Mãi một đời mong chờ, một giấc mơ (I shouldn't love you)` },
        { start: 173, end: 179, text: `Và từng đêm em mơ, em mơ, em mơ, em mơ như thế` },
        { start: 179, end: 182, text: `Từng cảm xúc cứ chiếm lấy em` },
        { start: 182, end: 185, text: `Từng nhịp trái tim cứ nóng lên` },
        { start: 185, end: 191, text: `Và em biết không nên, không nên, không nên, không nên như thế (uhm)` },
        { start: 191, end: 194, text: `Vì thật khó để giữ lấy anh` },
        { start: 194, end: 198, text: `Vì thật khó cho em nếu như phải lòng anh` },
        { start: 198, end: 204, text: `Nếu không là bây giờ, sẽ không là bao giờ` },
        { start: 204, end: 210, text: `Mãi một đời mong chờ, một giấc mơ (I shouldn't love you)` },
        { start: 210, end: 216, text: `Nếu không là bây giờ, sẽ không là bao giờ` },
        { start: 216, end: 226, text: `Mãi một đời mong chờ, một giấc mơ (I shouldn't love you)` },
    ],
    'doi-muoi': [
        { start: 14, end: 19, text: `Em hãy cứ lang thang dưới những tán cây` },
        { start: 19, end: 24, text: `Hãy cứ gối lên đôi chân anh suốt ngày` },
        { start: 24, end: 30, text: `Nếu muốn hát lên cho thêm huyên náo đâu cần phải ngó quanh (hmmm)` },
        { start: 30, end: 35, text: `Vì trời đất kia là của chúng mình` },
        { start: 35, end: 40, text: `Anh sẽ nói yêu em từ ngày đến đêm` },
        { start: 40, end: 46, text: `Sẽ vẫn đón đưa em dù đường sẽ xa thêm` },
        { start: 46, end: 51, text: `Vứt hết những thói quen không quan trọng để an ủi em mỗi khi bất bình` },
        { start: 51, end: 56, text: `Thời gian ấy của riêng chúng mình` },
        { start: 56, end: 60, text: `Em đẹp tựa như khúc ca` },
        { start: 60, end: 65, text: `Mà anh vẫn ngân nga bên ô cửa đầy nắng ấm` },
        { start: 65, end: 69, text: `Hãy đan tay giữa phố tan tầm` },
        { start: 69, end: 73, text: `Và ghi nhớ những tháng ngày mà ta đang yêu` },
        { start: 73, end: 79, text: `Những ngày ta đôi mươi, những ngày ta rất vui` },
        { start: 79, end: 84, text: `Những ngày em bên anh đưa tay ta hái sao trên bầu trời` },
        { start: 84, end: 90, text: `Lời hứa ghi trên bờ môi, dẫu một mai thế giới kia ngừng trôi` },
        { start: 90, end: 92, text: `Ôi những ngày mà ta đôi mươi` },
        { start: 92, end: 100, text: `Dành tất cả nhiệt thành để yêu một người` },
        { start: 107, end: 112, text: `Chẳng muốn nhớ về lời tỏ tình đánh rơi` },
        { start: 112, end: 118, text: `Chẳng muốn đắn đo lý do em đáp lời` },
        { start: 118, end: 124, text: `Chẳng muốn nghĩ xung quanh ai nghi vấn ta liệu có xứng đôi` },
        { start: 124, end: 128, text: `Ta vẫn cứ yêu nhau đấy thôi` },
        { start: 128, end: 132, text: `Và nếu một ngày em lỡ quên` },
        { start: 132, end: 137, text: `Ngày anh đứng bên hiên mưa tuôn chờ em bước tới` },
        { start: 137, end: 141, text: `Sẽ ngân nga về em đôi lời` },
        { start: 141, end: 148, text: `Về năm tháng đẹp tươi mình từng bên nhau mãi không xa rời (hoh-uh-oh)` },
        { start: 148, end: 153, text: `Những ngày ta đôi mươi, những ngày ta rất vui` },
        { start: 153, end: 158, text: `Những ngày em bên anh đưa tay ta hái sao trên bầu trời` },
        { start: 158, end: 164, text: `Lời hứa ghi trên bờ môi dẫu một mai thế giới kia ngừng trôi` },
        { start: 164, end: 167, text: `Ôi những ngày mà ta đôi mươi` },
        { start: 167, end: 175, text: `Dành tất cả nhiệt thành để yêu một người` },
        { start: 192, end: 195, text: `La la la la` },
        { start: 195, end: 198, text: `La la la la` },
        { start: 198, end: 201, text: `La la la la` },
        { start: 201, end: 203, text: `Anh muốn sống mãi tuổi đôi mươi` },
        { start: 203, end: 206, text: `La la la la` },
        { start: 206, end: 209, text: `La la la la la` },
        { start: 209, end: 212, text: `La la la la` },
        { start: 212, end: 215, text: `Những ngày ta đôi mươi` },
        { start: 215, end: 217, text: `Những ngày ta rất vui` },
        { start: 217, end: 222, text: `Những ngày em bên anh đưa tay ta hái sao trên bầu trời` },
        { start: 222, end: 229, text: `Lời hứa ghi trên bờ môi, dẫu một mai thế giới kia ngừng trôi` },
        { start: 229, end: 231, text: `Ôi những ngày mà ta đôi mươi` },
        { start: 231, end: 235, text: `Dành tất cả nhiệt thành để yêu một người` },
        { start: 235, end: 238, text: `La la la la` },
        { start: 238, end: 240, text: `La la la la` },
        { start: 240, end: 243, text: `La la la la` },
        { start: 243, end: 246, text: `Anh muốn sống mãi tuổi đôi mươi` },
        { start: 246, end: 248, text: `La la la la` },
        { start: 248, end: 251, text: `La la la la la (uh-uh-uh)` },
        { start: 251, end: 254, text: `La la la la` },
        { start: 254, end: 259, text: `Anh muốn sống mãi tuổi đôi mươi` },
    ],
    'dua-nao-lam-em-buon': [
        { start: 20, end: 24, text: `Anh biết tay em còn bắt máy tai em còn muốn nghe đôi ta còn hi vọng` },
        { start: 24, end: 28, text: `Ném anh trăm lời quát mắng vứt một lời chia tay đừng tặng anh im lặng` },
        { start: 28, end: 33, text: `Không giỏi nhìn người yêu anh buồn anh chỉ giỏi làm người yêu anh buồn thôi` },
        { start: 33, end: 36, text: `Bằng những lời anh cắn chặt mà môi hôn đắm nhất chẳng thể làm buột môi` },
        { start: 36, end: 41, text: `Mỗi khi em hỏi mai sau của chúng ta xin lỗi anh luôn lờ đi thật vô tình` },
        { start: 41, end: 44, text: `Cứ coi nó như làn mi treo ngay trước mắt nhưng vô hình` },
        { start: 44, end: 49, text: `Dù anh biết hạnh phúc của em muốn là hàng ngày tan ca ở nhà chờ đón anh` },
        { start: 49, end: 53, text: `Nhưng hạnh phúc của anh là thấy em hạnh phúc dù lúc đó là em chẳng có anh` },
        {
            start: 53,
            end: 57,
            text: `Xin em đừng nghĩ là anh không yêu em khi anh chẳng hứa tương lai mình tới đâu`,
        },
        { start: 57, end: 61, text: `Thương em thì anh mới làm vậy bởi lời hứa và dối trá nó có họ với nhau` },
        { start: 61, end: 65, text: `Và em ơi dù ở trong tình yêu anh không phải là kẻ tử tế nhất` },
        { start: 65, end: 69, text: `Nhưng anh chẳng đủ tệ để lấy cả thanh xuân của em mà không có thế chấp` },
        { start: 69, end: 73, text: `Em đang có đủ tất cả để thành hôn trừ một gã người yêu đủ gọi là thành đạt` },
        { start: 73, end: 77, text: `Lỡ em anh lỡ cả kho báu lỡ anh em chỉ lỡ một canh bạc` },
        { start: 77, end: 82, text: `Nên anh chẳng hiểu nổi được lí do còn đây sau bao ngày dài hao` },
        { start: 82, end: 85, text: `Chắc chắn là em còn yêu anh nhưng thứ anh không chắc duy nhất là tại sao` },
        { start: 85, end: 89, text: `Đứa nào làm em buồn thế` },
        { start: 89, end: 93, text: `Nó yêu em nhưng nó tệ` },
        { start: 93, end: 97, text: `Không một lời nào hẹn hứa sau này sẽ đến đâu` },
        { start: 97, end: 101, text: `Không một nửa câu chắc chắn cho nhau` },
        { start: 101, end: 106, text: `Đứa mà làm em buồn ấy` },
        { start: 106, end: 110, text: `Sao mà em thích nó đến vậy` },
        { start: 110, end: 119, text: `Sao toàn làm em rơi nước mắt vậy mà em vẫn còn ở đây` },
        { start: 119, end: 123, text: `Anh đâu muốn lạc mất em chỉ vì lạc quan là thứ chưa thể giỏi` },
        { start: 123, end: 127, text: `Nhưng anh sợ tình ta như tay đua về sau chẳng có gì ngoài mệt mỏi` },
        { start: 127, end: 131, text: `Không dám đưa em về nơi anh sống vì ở đó chôn cất phiền ưu riêng` },
        { start: 131, end: 135, text: `Anh sợ thăm nhà anh một lát em biết mình sẽ mãi chẳng đứng đầu ưu tiên` },
        {
            start: 135,
            end: 139,
            text: `Em sẽ biết anh cất đâu lời hứa mà bước vào tình chẳng đem nổi nửa câu (cất đâu nửa câu)`,
        },
        {
            start: 139,
            end: 143,
            text: `Dăm ba cái sau này con lớn với sau này cháu lớn nên anh còn nữa đâu (uh huh)`,
        },
        {
            start: 143,
            end: 147,
            text: `Chứ ai muốn làm người yêu mình buồn anh cũng muốn hứa em một ngày mai sáng (ai anh muốn)`,
        },
        {
            start: 147,
            end: 151,
            text: `Ta yêu gấp mấy lần người thường không biết cưới bao nhiêu đám thì mới đáng (gấp mấy bao nhiêu)`,
        },
        { start: 151, end: 155, text: `Nhưng sao dám khi mai này thế nào đâu biết được dù mình có biếng chăm` },
        {
            start: 155,
            end: 160,
            text: `Chim gõ kiến có thể đói vỡ mồm kể cả nó chỉ có cắm mặt vào kiếm ăn (kiếm ăn)`,
        },
        {
            start: 160,
            end: 164,
            text: `Thật quá đáng nếu anh bắt em thông cảm với giông bão chắc chắn sẽ tới sau (tới sau)`,
        },
        { start: 164, end: 168, text: `Cùng anh nếu được thì ăn cả còn ngã về nhà mình ăn ngủ với nhau` },
        { start: 168, end: 171, text: `Nên nói không anh cũng sẽ hiểu rõ ràng đặt cược vào anh là quá liều` },
        { start: 171, end: 176, text: `Vì kẻ như anh mà một người buồn thôi thực sự con số đấy đã là quá nhiều` },
        {
            start: 176,
            end: 180,
            text: `Người như em xứng được che bởi bóng râm thay vì tăm tối của một bầu trời đen`,
        },
        { start: 180, end: 183, text: `Anh không muốn tất cả ưu phiền em có chỉ đến từ một nửa của đời em (có)` },
        { start: 183, end: 188, text: `Đứa nào làm em buồn thế` },
        { start: 188, end: 191, text: `Nó yêu em nhưng nó tệ` },
        { start: 191, end: 195, text: `Không một lời nào hẹn hứa sau này sẽ đến đâu` },
        { start: 195, end: 200, text: `Không một nửa câu chắc chắn cho nhau` },
        { start: 200, end: 204, text: `Đứa mà làm em buồn ấy` },
        { start: 204, end: 208, text: `Sao mà em thích nó đến vậy` },
        { start: 208, end: 219, text: `Sao toàn làm em rơi nước mắt vậy mà em vẫn còn ở đây` },
        { start: 219, end: 222, text: `Sao em không thể xa anh mau (xa anh mau)` },
        { start: 222, end: 228, text: `Tương lai anh không chắc như bờ vai anh đâu (anh đâu)` },
        { start: 228, end: 230, text: `Buông anh đi thì sao nào` },
        { start: 230, end: 236, text: `Buông anh đi thì sao nào (buông anh đi)` },
        { start: 236, end: 239, text: `Sao em không thể xa anh mau (xa anh mau)` },
        { start: 239, end: 244, text: `Tương lai anh không chắc như bờ vai anh đâu (anh đâu)` },
        { start: 244, end: 246, text: `Buông anh đi thì sao nào` },
        { start: 246, end: 251, text: `Buông anh đi` },
    ],
    'anh-mo': [
        { start: 17, end: 21, text: `Sáng nay anh được gặp em` },
        { start: 21, end: 25, text: `Lòng anh hạnh phúc thật nhiều` },
        { start: 25, end: 29, text: `Được nghe em nói thật nhẹ nhàng biết mấy` },
        { start: 29, end: 35, text: `Và giây phút này mong sao ngừng trôi` },
        { start: 35, end: 38, text: `Đã bao thời gian anh mơ` },
        { start: 38, end: 42, text: `Được nhìn em hé nụ cười` },
        { start: 42, end: 47, text: `Người ơi em có hiểu được anh không?` },
        { start: 47, end: 54, text: `Lòng anh thẫn thờ yêu em nhiều lắm..` },
        { start: 54, end: 58, text: `Ước mong thời gian sẽ quay trở lại` },
        { start: 58, end: 62, text: `Để anh được nói với em thêm một câu` },
        { start: 62, end: 66, text: `Rằng ngày mai nếu có gặp lại nhau` },
        { start: 66, end: 71, text: `Thì em có cần tay anh ôm em thật lâu` },
        { start: 71, end: 75, text: `Chúc em ngày mai sẽ luôn thật vui` },
        { start: 75, end: 79, text: `Ở nơi xa ấy có nắng ru tình em` },
        { start: 79, end: 84, text: `Còn anh sẽ nhớ nhớ mãi nụ cười ấy` },
        { start: 84, end: 89, text: `Chờ nghe những lời yêu thương trìu mến` },
        { start: 89, end: 95, text: `Anh mơ...` },
        { start: 110, end: 114, text: `Ước mong thời gian sẽ quay trở lại` },
        { start: 114, end: 119, text: `Để anh được nói với em thêm một câu` },
        { start: 119, end: 123, text: `Rằng ngày mai nếu có gặp lại nhau` },
        { start: 123, end: 127, text: `Thì em có cần tay anh ôm em thật lâu` },
        { start: 127, end: 132, text: `Chúc em ngày mai sẽ luôn thật vui` },
        { start: 132, end: 136, text: `Ở nơi xa ấy có nắng ru tình em` },
        { start: 136, end: 141, text: `Còn anh sẽ nhớ nhớ mãi nụ cười ấy` },
        { start: 141, end: 145, text: `Chờ nghe những lời yêu thương trìu mến` },
        { start: 145, end: 153, text: `Anh mơ...` },
        { start: 153, end: 155, text: `Và từng ngày anh mơ từng ngày` },
        { start: 155, end: 159, text: `Và từng ngày anh mơ từng ngày` },
        { start: 159, end: 161, text: `Và từng ngày anh mơ từng ngày` },
        { start: 161, end: 169, text: `Và từng ngày anh mơ từng ngày` },
    ],
};

export default PLAYLIST_CHILL_LYRICS;
